import { render, staticRenderFns } from "./AppSupport.vue?vue&type=template&id=f1f8e6e4&scoped=true&"
import script from "./AppSupport.vue?vue&type=script&lang=js&"
export * from "./AppSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f8e6e4",
  null
  
)

export default component.exports